'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
const ARROW_LEFT = 'ArrowLeft';
const ARROW_UP = 'ArrowUp';
const ARROW_RIGHT = 'ArrowRight';
const ARROW_DOWN = 'ArrowDown';
const ENTER = 'Enter';
const ESCAPE = 'Escape';
const SPACE = 'Space';
const TAB = 'Tab';
const BACKSPACE = 'Backspace';
const KEY_V = 'KeyV';
exports.ARROW_DOWN = ARROW_DOWN;
exports.ARROW_LEFT = ARROW_LEFT;
exports.ARROW_RIGHT = ARROW_RIGHT;
exports.ARROW_UP = ARROW_UP;
exports.BACKSPACE = BACKSPACE;
exports.ENTER = ENTER;
exports.ESCAPE = ESCAPE;
exports.KEY_V = KEY_V;
exports.SPACE = SPACE;
exports.TAB = TAB;
